import styled from '@emotion/styled'
import { ContentArea } from './ContentArea'

export const CenterContent = styled(ContentArea)`
	align-items: center;
	justify-content: center;
`
